const enum ErrorSubType {
  GA_EXCEPTION = "GA_EXCEPTION",
}

export default ErrorSubType;
